import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <Layout theme="white">
      <div className="content-centered">
        <h1 className="heading-lg" style={{ color: 'var(--text-primary)' }}>
          Page not found
        </h1>
        <p style={{ marginTop: 16, color: 'var(--text-secondary)' }}>
          The page you're looking for doesn't exist.
        </p>
        <Button
          variant="primary"
          style={{ marginTop: 32 }}
          onClick={() => navigate('/')}
        >
          Go Home
        </Button>
      </div>
    </Layout>
  );
}
